module.exports = __webpack_public_path__ + "static/nus-logo-3e4d4db2dde5b428e8a0a657e74d6c12.png";